import React, { useState, useEffect, useRef } from "react";
import style from "css/landing.module.css";
import HistoryItem from "./historyItem";
import { useMediaQuery } from "react-responsive";

function History() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const historyRef = useRef(null);
  const [isVisible, setVisible] = useState(false);
  const historyList = [
    {
      type: "text",
      year: "2024",
      title: "all Place",
      text: "하이브리드 워크를 위한 스마트 공간 예약 플랫폼",
      color: "#111111",
    },
    {
      type: "text",
      year: "2024",
      title: "Device One",
      text: "강의실 전용 neat 디바이스 컨트롤 및 관리 시스템",
      color: "#5464f5",
    },
    {
      type: "text",
      year: "2024",
      title: "Medi Link",
      text: "원격 협진을 위한 안전한 비대면 진료 플랫폼",
      color: "#022759",
    },
    {
      type: "text",
      year: "2023",
      title: "Be gate",
      text: "클라우드 화상회의와 시스템을 연결하는 최적의 솔루션",
      color: "#fe9d12",
    },
    {
      type: "img",
      year: "2023",
      title: "Private Connect Manager",
      text: "Private connect의 운용/관리를 위한 관리자 전용 시스템",
      img: "img/landing/history/private_connect_manager.png",
      img_m: "img/landing/history/private_connect_manager_m.png",
      img_over: "img/landing/history/private_connect_manager_over.png",
      color: "#e16449",
    },
    {
      type: "img",
      year: "2019",
      title: "WESS",
      text: "기존 App과 Zoom/Webex의 API 연동",
      img: "img/landing/history/wess.png",
      img_m: "img/landing/history/wess_m.png",
      img_over: "img/landing/history/wess_over.png",
      color: "#f9a519",
    },
    {
      type: "img",
      year: "2018",
      title: "RSP",
      text: "Poly 영상 장비에 특화된 연동 솔루션",
      img: "img/landing/history/rsp.png",
      img_m: "img/landing/history/rsp_m.png",
      img_over: "img/landing/history/rsp_over.png",
      color: "#f37820",
    },
    {
      type: "img",
      year: "2017",
      title: "VE Manager for CMS",
      text: "맞춤형 영상회의 예약및 관리 솔루션",
      img: "img/landing/history/ve_manager_cms.png",
      img_m: "img/landing/history/ve_manager_cms_m.png",
      img_over: "img/landing/history/ve_manager_cms_over.png",
      color: "#f37820",
    },
  ];
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting));
    });

    if (historyRef.current) {
      observer.observe(historyRef.current);
    }
    return () => {
      if (historyRef.current) {
        observer.unobserve(historyRef.current);
      }
    };
  }, []);
  return (
    <div className={style.history_wrap} ref={historyRef}>
      <div
        className={style.history_text_wrap}
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible
            ? "translate3d(0, 0, 0)"
            : "translate3d(0, 50%, 0)",
          transition:
            "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
        }}
      >
        <div className={style.history_title}>
          Riv<span>가 만들어 온{"\n"} </span>History<span> & </span>Story
        </div>
        <div className={style.history_text}>
          Story가 모여 이뤄낸 Riv의 기술력
        </div>
      </div>

      <div
        className={style.history_grid_area}
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible
            ? "translate3d(0, 0, 0)"
            : "translate3d(0, 50%, 0)",
          transition:
            "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
        }}
      >
        {historyList.map((history, index) => (
          <HistoryItem history={history} key={index} />
        ))}
      </div>
    </div>
  );
}

export default History;
